export default __webpack_public_path__ + "static/media/Bloodsnare Gloves.4cf4a3da.jpg";